import { createContext } from "react"

const AreasManagementContext = createContext();

export default AreasManagementContext;